module.exports = __webpack_public_path__ + "81952a5fc0c2d99f17819c146d992f1c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/practice-question-1.png
// module id = 1122
// module chunks = 0